const API_URL = process.env.REACT_APP_API_URL;
const API_TIMEOUT = 10 * 1000; // in milliseconds
const API_TIMEOUT_FILE = 3 * 60 * 1000; // in milliseconds

export { API_URL, API_TIMEOUT, API_TIMEOUT_FILE };
